import React, { useState } from 'react';
import { X, Play, Trash2 } from 'lucide-react';
import { useQuiz } from '../context/QuizContext';
import { t } from '../i18n';
import ConfirmDialog from './ConfirmDialog';

const fmt = (iso) => {
  try { return new Date(iso).toLocaleString(); } catch { return iso; }
};

const HistoryModal = ({ onClose }) => {
  const { history, loadFromHistory, deleteHistory, lang } = useQuiz();
  const [pendingDeleteId, setPendingDeleteId] = useState(null);

  return (
    <>
    <div className="mg-modal-overlay" onClick={onClose}>
      <div className="mg-modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 720 }}>
        <div className="mg-modal-head">
          <div className="mg-title" style={{ fontSize: 18 }}>{t('historyTitle', lang)}</div>
          <button className="mg-close-x" style={{ position: 'static' }} onClick={onClose}><X size={16} /></button>
        </div>
        <div className="mg-modal-body">
          {history.length === 0 && (
            <div style={{ textAlign: 'center', padding: 30, color: '#6b7280' }}>{t('empty', lang)}</div>
          )}
          {history.map(h => (
            <div key={h.id} className="mg-preview-q" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <div>
                <div style={{ fontWeight: 700 }}>{h.quizTitle}</div>
                <div style={{ fontSize: 12, color: '#6b7280' }}>{t('savedAt', lang)}: {fmt(h.savedAt)} · {h.questions.length} {lang === 'id' ? 'soal' : 'questions'}</div>
              </div>
              <div style={{ display: 'flex', gap: 6 }}>
                <button className="mg-btn success" style={{ width: 'auto', padding: '6px 12px' }} onClick={() => { loadFromHistory(h.id); onClose(); }}>
                  <Play size={14} /> {t('load', lang)}
                </button>
                <button className="mg-btn danger" style={{ width: 'auto', padding: '6px 12px' }} onClick={() => setPendingDeleteId(h.id)}>
                  <Trash2 size={14} />
                </button>
              </div>
            </div>
          ))}
        </div>
        <div className="mg-modal-foot">
          <button className="mg-btn ghost" style={{ width: 'auto', padding: '8px 14px' }} onClick={onClose}>{t('close', lang)}</button>
        </div>
      </div>
    </div>

      <ConfirmDialog
        open={pendingDeleteId !== null}
        onOpenChange={(v) => { if (!v) setPendingDeleteId(null); }}
        title={t('confirmDeleteTitle', lang)}
        description={t('confirmDeleteDesc', lang)}
        confirmLabel={t('confirmDeleteAction', lang)}
        cancelLabel={t('cancel', lang)}
        danger
        onConfirm={() => { deleteHistory(pendingDeleteId); setPendingDeleteId(null); }}
      />
    </>
  );
};

export default HistoryModal;
